export const FIELD_TYPES = {
  STRING: "string",
  NUMERIC: "number",
  LIST: "list",
  BOOLEAN: "boolean"
};

export const INPUT = "input";
